import React, { Component } from 'react';
import { Spin } from 'antd';
import TableC from '../../basicElement/TableC';
import ImportantEventTable from '../ImportantEventTable';

class MinusContent extends Component {
    getStrongRender = (text, record) => {
        if (record.itemName.startsWith('合计')) {
            return <strong>{text}</strong>;
        }
        return text;
    }

    getMinusTable = () => {
        const { restDatas: { minusData = [] } } = this.props;
        const getColumns = () => {
            const columns = [{
                title: '考核项',
                dataIndex: 'itemName',
                render: (text, record) => {
                    const { fullScore, itemName } = record;
                    if (itemName.startsWith('合计')) {
                        return <strong>{text}{fullScore ? `（下限${fullScore}分）` : ''}</strong>;
                    }
                    return fullScore ? `${text}（下限${fullScore}分）` : text;
                }
            }, {
                title: '得分',
                dataIndex: 'score',
                render: this.getStrongRender,
            }];
            return columns;
        };

        return (
            <TableC
                data={minusData}
                columns={getColumns()}
                rowKey="performanceItemId"
                pagination={false}
            />
        )
    }

    render() {
        const { loading, restDatas: { majorEvent = [] } } = this.props;
        return (
            <Spin spinning={loading}>
                <div style={{ lineHeight: '48px' }}>1.减分明细</div>
                {this.getMinusTable()}
                <div style={{ lineHeight: '48px' }}>2.重大事件发生明细</div>
                {<ImportantEventTable data={majorEvent} />}
            </Spin>
        );
    }
}

export default MinusContent;


// WEBPACK FOOTER //
// ./src/components/home/pmPerformanceDetail/MinusContent.js